// extracted by mini-css-extract-plugin
module.exports = {"success":"styles_success___Dvju","success__ok-wrapper":"styles_success__ok-wrapper__Ikh7_","success__text":"styles_success__text__ajKbY"};